
import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TsunamiMap from '../TsunamiMap/TsunamiMap';
import Login from '../Login/Login';
import useToken from './useToken';
/*
import ingv_data from '../../data/ingv.json';
import ipma_data from '../../data/ipma.json';
import koeri_data from '../../data/koeri.json';
import noa_data from '../../data/noa.json';
import cenalt_data from '../../data/cenalt.json';
*/

function App() {
    const { token, setToken} = useToken();

    if(!token) {
        return <Login setToken={setToken} />
    }
    return (
        <div className="login_area">
            <div className="form_part">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={
                            <TsunamiMap />
                        }>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </div>
    );
}

export default App;

